@if (vm$ | async; as vm) {
    @if (loading) {
        <div class="loading-container flex align-center justify-center">
            <mat-progress-spinner
                class="example-margin"
                mode="indeterminate">
            </mat-progress-spinner>
        </div>
    }
    <img #img src="{{ asset.image }}" class="hidden" />
    <canvas
        #canvas
        width="{{ bounds.width }}"
        height="{{ bounds.height }}"
        (mousedown)="mouseDown($event, vm.presentingState)"
        (wheel)="zoom($event, vm.presentingState)"
    ></canvas>
}
